(() => {
  const offerAliases = {
    allgemein: 'Allgemeine Kontaktaufnahme',
    contact: 'Allgemeine Kontaktaufnahme',
    'ki-fuer-organisationen': 'Erstgespräch für Organisationen',
    'ki-orientierung-strategie': 'Erstgespräch für Organisationen',
    'ki-verwaltung-gemeinden': 'Erstgespräch für Organisationen',
    'ki-alter-pflege': 'Erstgespräch für Organisationen',
    'ki-schulungen': 'Firmeninterne Schulung',
    'firmeninterne-ki-schulungen': 'Firmeninterne Schulung',
    inspirationssession: 'Inspirationssession',
    'prompting-schulung': 'Prompting-Schulung',
    'ki-online-sprechstunde': 'Persönliche Einzellektion – online oder vor Ort',
    'ki-persoenlich': 'Persönliche Einzellektion – online oder vor Ort',
    'ki-einzellektion': 'Persönliche Einzellektion – online oder vor Ort',
    'Persönliche Einzellektion – online oder vor Ort': 'Persönliche Einzellektion – online oder vor Ort',
    'ki-training-vor-ort': 'KI-Training vor Ort',
    'ki-fuehrung-governance': 'Führung und Governance',
    'm365-arbeitsprozesse': 'Microsoft 365 und Arbeitsprozesse',
    'potenzial-use-case-analyse': 'Potenzial- oder Use-Case-Analyse',
    anderes: 'anderes Anliegen'
  };

  const form = document.querySelector('#DSContactForm');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const requestedOffer = params.get('angebot');
  const offerSelect = form.querySelector('[data-ds-offer-select]');

  if (requestedOffer && offerSelect) {
    const mappedOffer = offerAliases[requestedOffer.toLowerCase()] || requestedOffer;
    const isAllowed = Array.from(offerSelect.options).some((option) => option.value === mappedOffer);
    if (isAllowed) offerSelect.value = mappedOffer;
  }

  const sourceInput = form.querySelector('[data-ds-contact-source]');
  if (sourceInput) {
    sourceInput.value = `${window.location.pathname}${window.location.search}`;
  }

  const successMessage = document.querySelector('[data-ds-form-success]');
  if (successMessage) successMessage.focus();
})();
